var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53835 6.58154L4.09013 6.58154L4.09013 14.2695L1.53835 14.2695C1.39557 14.2695 1.25864 14.2053 1.15768 14.091C1.05672 13.9768 1 13.8218 1 13.6603L1 7.19073C1 7.02916 1.05672 6.87422 1.15768 6.75997C1.25864 6.64573 1.39557 6.58154 1.53835 6.58154Z",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09009 6.58102L6.8249 1.63443C6.93089 1.43892 7.07982 1.2778 7.25719 1.16677C7.43455 1.05574 7.63432 0.998596 7.837 1.00088C7.99664 0.994359 8.1558 1.02412 8.30509 1.08839C8.45439 1.15267 8.59078 1.25015 8.70622 1.3751C8.82165 1.50004 8.91378 1.64989 8.97715 1.81582C9.04053 1.98173 9.07387 2.16034 9.0752 2.34109L9.0752 5.88655L13.8019 5.88655C13.9766 5.89296 14.148 5.94112 14.3051 6.0279C14.4621 6.11466 14.6011 6.23805 14.713 6.38996C14.8249 6.54187 14.9071 6.71885 14.9542 6.90928C15.0013 7.0997 15.0122 7.29925 14.9863 7.4948L14.1249 13.7816C14.0882 14.1176 13.9442 14.4268 13.7202 14.6512C13.4962 14.8756 13.2074 14.9996 12.9082 15L5.8451 15C5.50888 15.0015 5.17701 14.9139 4.87608 14.7441L4.10085 14.3055",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09009 6.58118L4.09009 14.2691",
    stroke: "#CFCED4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.2e3e5b87ca8ee0a412183e56451e4189.svg";
export { ForwardRef as ReactComponent };